export const loadingChunkRetry = (fn, retriesLeft = 5, interval = 1000) => {
    return new Promise((resolve, reject) => {
        fn()
            .then(resolve)
            .catch((error) => {
            setTimeout(() => {
                if (retriesLeft === 1) {
                    // reject('maximum retries exceeded')
                    reject(error);
                    return;
                }
                // Passing on 'reject' is the important part
                loadingChunkRetry(fn, retriesLeft - 1, interval * (6 - retriesLeft)).then(resolve, reject);
            }, interval);
        });
    });
};
//# sourceMappingURL=react.js.map